import React, { useContext, useState } from "react";
import { ResearchContext } from "../../Context/ResearchContext";
import css from "./UserPage.module.css";

export const Results = () => {
  const { participants } = useContext(ResearchContext);

  // 1. Estados para controlar o modal e o usuário selecionado
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 2. Funções de abrir e fechar o modal
  const openModal = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedUser(null);
    setIsModalOpen(false);
  };

  return (
    <section className={css.container}>
      <div>
        <h2>Resultados</h2>
        <div>
          {!participants?.length ? (
            <p>Não foram encontrados participantes cadastrados na pesquisa</p>
          ) : (
            participants.map((p) => (
              <div key={p.id} className={css.card}>
                <div className={css.cardBody}>
                  <p>Id: {p.id}</p>
                  <p>
                    Cadastro em:{" "}
                    {new Date(p.createdAt).toLocaleDateString("pt-BR", {
                      weekday: "long",
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                  <p>Ansiedade {p.DASSanx}</p>
                  <p>Depressão {p.DASSdep}</p>
                  <p>Estresse {p.DASSstr}</p>
                  <p>Treino 1: {Number(p.Trial1score).toFixed(2)}%</p>
                  <p>Tentativas: {p.Trial1attempts}</p>
                  <p>Teste 1: {Number(p.Test1score).toFixed(2)}%</p>
                  <p>Treino 2: {Number(p.Trial2score).toFixed(2)}%</p>
                  <p>Tentativas: {p.Trial2attempts}</p>
                  <p>Teste 2: {Number(p.Test2score).toFixed(2)}%</p>
                  <p>SessionTime: {Number(p.sessionTime).toFixed(2)}%</p>

                  {/* 3. Botão para acionar o modal passando o usuário atual */}
                  <button
                    className="greenButton"
                    onClick={() => openModal(p)}
                    style={{ marginTop: "10px" }}
                  >
                    Ver Avaliação de Palavras
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* 4. Estrutura e lógica de renderização do Modal */}
      {isModalOpen && selectedUser && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3>
                Avaliação de Palavras - {selectedUser.name || selectedUser.id}
              </h3>
              <button onClick={closeModal} style={closeButtonStyle}>
                X
              </button>
            </div>

            <div
              style={{
                marginTop: "1rem",
                maxHeight: "400px",
                overflowY: "auto",
              }}
            >
              {selectedUser.WordVal && selectedUser.WordVal.length > 0 ? (
                <table
                  style={{
                    width: "100%",
                    textAlign: "left",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead>
                    <tr style={{ borderBottom: "2px solid #ddd" }}>
                      <th style={{ padding: "8px" }}>Palavra</th>
                      <th style={{ padding: "8px" }}>Valência</th>
                      <th style={{ padding: "8px" }}>Tempo de Reação (ms)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Renderiza a matriz de palavras submetida do Words.js */}
                    {selectedUser.WordVal.map((item, idx) => (
                      <tr key={idx} style={{ borderBottom: "1px solid #eee" }}>
                        <td style={{ padding: "8px" }}>
                          <strong>{item.word}</strong>
                        </td>
                        <td style={{ padding: "8px" }}>{item.valence}</td>
                        <td style={{ padding: "8px" }}>{item.reactionTime}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>
                  Nenhuma avaliação de palavras registrada para este
                  participante.
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalContentStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  width: "90%",
  maxWidth: "600px",
  color: "#333",
  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
};

const closeButtonStyle = {
  cursor: "pointer",
  padding: "5px 10px",
  backgroundColor: "#f44336",
  color: "white",
  border: "none",
  borderRadius: "4px",
  fontWeight: "bold",
};
